
import { defineComponent, PropType } from 'vue'
export default defineComponent({
  name: 'BaseClickedCheckbox',
  props: {
    disabled: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    },
    theme: {
      type: String as PropType<string>,
      required: false,
      default: ''
    },
    checked: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false
    }
  },
  emits: ['clickHandler'],
  methods: {
    clickHandler (): void {
      this.$emit('clickHandler')
    }
  }
})
